import React, { useEffect } from 'react';
import './OdHeader.scss';
import { useDispatch, useSelector } from 'react-redux';
import Logo from './Logo/Logo';
import NavLinks from './NavLinks/NavLinks';
import NavActions from './NavActions/NavActions';
import Banner from './Banner/Banner';
import { getMainNav } from '../../../actionCreators/header';

const OdHeader = props => {
  const navigation = useSelector(state => state?.header?.mainNavigationData?.navigation);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMainNav());
  }, []);

  useEffect(() => {
    console.log('this is navigation desktop===>', navigation);
  }, [navigation]);

  if (navigation && Array.isArray(navigation) && navigation.length > 0) {
    return (
      <>
        <Banner />
        <header className="odHeader">
          <Logo />
          <NavLinks />
          <NavActions {...props} />
        </header>
      </>
    );
  }

  return null;
};

export default OdHeader;
